export class LikeLabel {
    constructor($label) {
        this.$label = $label;

        this.triggerClick = this.triggerClick.bind(this);
        this.$label.addEventListener('click', this.triggerClick);
    }

    triggerClick(e) {
        e.preventDefault();
        e.stopPropagation();

        var evt = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });

        this.$label.parentNode.querySelector('[data-like]').dispatchEvent(evt);
    }
}

export class LikeToggle {
    constructor($toggle) {
        this.$toggle = $toggle;
        this.$label = $toggle.parentNode.querySelector('[data-like-label]');
        this.objectType = $toggle.dataset.objectType;
        this.objectId = $toggle.dataset.objectId;

        this.toggle = this.toggle.bind(this);
        this.notifyBackend = this.notifyBackend.bind(this);
        this.$toggle.addEventListener('click', this.toggle);
    }

    toggle(e) {
        e.preventDefault();
        const $toggles = document.querySelectorAll('[data-toggle-like][data-object-type="' + this.objectType + '"][data-object-id="' + this.objectId + '"]')

        $toggles.forEach($toggle => {
            $toggle.querySelector('[data-toggle-like-active]').classList.toggle('d-none');
            $toggle.querySelector('[data-toggle-like-in-active]').classList.toggle('d-none');
        })

        this.notifyBackend();
    }

    async notifyBackend() {
        const body = JSON.stringify({
            objectType: this.objectType,
            objectId: this.objectId
        });

        try {
            const request = await fetch(
                    placeholders.baseUri
                            ? placeholders.baseUri + '/ajax-data/account/like-toggle'
                            : '/ajax-data/account/like-toggle'
                    ,
                    {
                        method: 'POST',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        },
                        body: body
                    }
            );
            const result = await request.json();
            return result;
        } catch (e) {
            console.log(e);
            this.loader.loading(false);
        }
    }
}